import { jsx as _jsx } from "react/jsx-runtime";
import DeviceLayout from "src/pages/deviceActivate/DeviceLayout";
import Zoiper5App from "src/features/deviceActivate/ActivateApp/Zoiper5App";
const Zoiper5ActivatePage = () => {
    return (_jsx(DeviceLayout, { children: _jsx(Zoiper5App, {}) }));
};
export default Zoiper5ActivatePage;
